import { mapActions } from "vuex";
import { get } from "@saas/server-api/src/request.js";
export default {
  beforeCreate() {
    const url = location.href;
    get("/v1/wechat/share?url=" + url).then((res) => {
      if (res.code === 1) {
        window?.wx &&
          window.wx.config({
            // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: res.data.app_id, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonce_str, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
            openTagList: ["wx-open-launch-app"], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
          });
      }
    });
    window?.wx &&
      window.wx.ready(function () {
        console.log("ready");

        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
      });

    window?.wx &&
      window.wx.error(function (res) {
        console.log("error", res);

        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
      });
  },
  mounted() {
    this.$nextTick(() => {
      var btn = document.getElementById("launch-btn");
      if (btn) {
        btn.addEventListener("launch", function (e) {
          console.log("lauch success");

          console.log(e);
        });
        btn.addEventListener("error", function (e) {
          console.log("fail", e.detail);
        });
      }
    });
  },
  methods: {},
};
